import { render, staticRenderFns } from "./buyMedicineHistory.vue?vue&type=template&id=6e794542&scoped=true&"
import script from "./buyMedicineHistory.vue?vue&type=script&lang=js&"
export * from "./buyMedicineHistory.vue?vue&type=script&lang=js&"
import style0 from "./buyMedicineHistory.vue?vue&type=style&index=0&id=6e794542&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e794542",
  null
  
)

export default component.exports